// extracted by mini-css-extract-plugin
module.exports = {"box":"Regular_style_box__1T1GR","wrap":"Regular_style_wrap__1yPp1"};